import { AxiosPromise } from 'axios';
import { apiService } from '@app/services';
import { infiniteScrollItemsFetchLimit } from '@app/helpers';

class NotificationService {
    readonly apiBase: string = '/api/directory/messages';

    getMessages(
        orderBy: string,
        asc: string,
        top: number,
        skip: number,
        count: boolean,
        handleError: Function,
        handleSuccess: Function
    ): AxiosPromise {
        return apiService
            .get(this.apiBase, {
                params: {
                    $orderBy: orderBy + ' ' + asc,
                    $top: top,
                    $count: count,
                    $skip: skip
                },
                onError: handleError,
                onSuccess: handleSuccess
            })
            .catch();
    }

    markAsRead(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(this.apiBase + '/MarkRead()', jsonObject, { onError: handleError, onSuccess: handleSuccess }).catch();
    }

    delete(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(this.apiBase + '/DeleteMany', jsonObject, { onError: handleError, onSuccess: handleSuccess }).catch();
    }

    getMessage(messageId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .get(this.apiBase + '(' + messageId + ')?$expand=Recipient&read=true', { local: true, onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    markMessageAsRead(messageId: string, jsonObject: any, handleError: Function, handleSuccess?: Function): AxiosPromise {
        return apiService.patch(this.apiBase + '(' + messageId + ')', jsonObject, { local: true, onError: handleError, onSuccess: handleSuccess }).catch();
    }

    getUnreadMessageCount(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(this.apiBase + '/GetUnreadMessageCount', { local: true, onError: handleError, onSuccess: handleSuccess }).catch();
    }

    getUnreadMessages(skip: number, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .get(this.apiBase, {
                params: {
                    $orderBy: 'Created desc, Important desc',
                    $top: infiniteScrollItemsFetchLimit,
                    $count: true,
                    $skip: skip,
                    $filter: 'IsRead eq false'
                },
                onError: handleError,
                onSuccess: handleSuccess,
                local: true
            })
            .catch();
    }

    notifyTenant(
        message: string,
        subject: string,
        tenants: string[],
        roles: string[],
        notifyEmail: boolean,
        handleError: Function,
        handleSuccess: Function
    ): AxiosPromise {
        let jsonObject: any = {};
        jsonObject.message = message;
        jsonObject.notifyEmail = notifyEmail;
        jsonObject.roles = roles.length ? "[" + ("\"" + roles.join("\", \"") + "\"") + "]" : '';
        jsonObject.subject = subject;
        jsonObject.tenants = tenants.length ? "[" + ("\"" + tenants.join("\", \"") + "\"") + "]" : '["*"]';

        return apiService.post('/api/directory/Tenants/NotifyTenant', jsonObject,
            { onError: handleError, onSuccess: handleSuccess }
        )
            .catch();
    }
}

export const notificationService = new NotificationService();
